import { useState, useEffect, useRef } from "react";
import { Form } from "react-bootstrap";
import check_example from "../../../assets/images/check_example.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "../../../axios";
import urls from "../../../Utils/urls";
import { useSelector } from "react-redux";
import { SpinnerBlock } from "../../../Utils/CustomComponent";
import FormBox from "../../../components/FormBox/FormBox";
import { useAbortController } from "../../../hooks/useAbortController";
import SignatureCanvas from "react-signature-canvas";

import {
  AchPaymentSchema,
  AuthenticationSchema,
} from "../../../Utils/formOptions";
import { toast } from "react-toastify";
import { commonToast } from "../../../Utils";
import moment from "moment";
import { LoadingButton } from "../../../Utils/CustomComponent";
import AuthenticationPopup from "./AuthenticationPopup";
import useBorowerLoanDetail from "../../../hooks/useBorowerLoanDetail";
import { loadingTypes } from "../../../Utils/constant";
// import classes from "../../../AllLoans/LoanDetails.module.css";
import classes from "../../Borrowers/Pages/AllLoans/LoanDetails.module.css";
import CustomBreadCrumbs from "../../../components/CustomBreadCrumbs";
// import classes from "../../Borrowers/pages/AllLoans/LoanDetails.module.css";

const NewBankAccountACHPayments = () => {
  const { signal } = useAbortController();
  const accountId = useSelector((state) => state.account.lenderId);
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const { loanDetails, status } = useBorowerLoanDetail(accountId);

  // const location = useLocation();
  const showAlert = loanDetails?.loanTerm?.achStatus
    ?.toLowerCase()
    ?.includes("you have a payment of");
  const dateStr = loanDetails?.loanTerm?.achStatus?.split("for")[1];
  const scheduledDate = moment(new Date(dateStr)).format("MM/DD/YYYY");

  const navigate = useNavigate();
  const [achInfo, setAchInfo] = useState(null);
  const [routingDetails, setRoutingDetails] = useState({});
  const [showPopup, setShowPopup] = useState(true);
  const [selectedOption, setSelectedOption] = useState("RP");
  const [showBankInfo, setShowBankInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [viewBill, setViewBill] = useState(false);
  const [otpPopup, setOtpPopup] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [data, setData] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  // const user = localStorage.getItem("accessed_user");

  const toggleBill = () => {
    setViewBill(!viewBill);
  };

  const defaultValues = {
    selectedReport: "0",
    selectedPaymentDay: "1",
    scheduledPaymentStatus: "1",
    selectedDate: new Date(moment().add(1, "days")),
    verifyAccountNumber: "0",
  };
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues,
    ...AchPaymentSchema,
  });

  const selectedReportWatch = watch("selectedReport");
  const routingNumber = watch("routingNumber");

  const paymentDays = [];

  for (let i = 1; i <= 28; i++) {
    paymentDays.push({ label: i.toString(), value: i.toString() });
  }

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const toggleBankInfo = () => {
    setShowBankInfo(!showBankInfo);
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handlePaymentOptions = () => {
    // eslint-disable-next-line eqeqeq
    if (!selectedOption == "") {
      togglePopup();
    }
  };

  useEffect(() => {
    if (selectedOption == null) {
      setShowPopup(true);
    }
  }, [selectedOption, showPopup]);

  useEffect(() => {
    const handleRoutingNumberValidation = async () => {
      setDisabled(true);
      const getData = await axios.get(
        urls.borrower.getRoutingNumberValidation(routingNumber),
        { signal }
      );
      if (getData.data?.message == "OK") {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
      setRoutingDetails(getData.data);
      return getData.data;
    };
    if (routingNumber?.length === 9 || routingNumber?.length > 9) {
      handleRoutingNumberValidation();
    }
    if (routingNumber?.length !== 9) {
      setDisabled(true);
    }
  }, [routingNumber]);
  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        urls.borrower.getPaymentsLoanAchInfo(accountId),
        { signal }
      );
      let data = res.data[0][0];

      setAchInfo(data);
      setValue("achDebitAmount", data?.ACH_DebitAmount);
      setValue("bankAccountName", data?.ACH_IndividualName);
      setValue("routingNumber", data?.ACH_RoutingNumber);
      setValue("accountNumber", data?.ACH_AccountNumber);
      if (data?.ACH_RoutingNumber.length === 9) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    };
    fetchData();
  }, [accountId, setValue]);

  const handleAuthentication = (data) => {
    setData(data);
    setOtpPopup(true);
  };

  useEffect(() => {
    if (isAuthenticated) {
      onSubmit(data);
    }
  }, [isAuthenticated]);

  async function onSubmit(data) {
    if (!isAuthenticated) return;
    setLoading(true);
    setDisabled(true);
    const id = toast.loading("Processing your request...");
    try {
      const res = await axios.post(
        urls.borrower.postPaymentsLoanAchInfo,
        {
          loanID: localStorage.getItem("borrowerLoanId"),
          ACH_RoutingNumber: data.routingNumber,
          ACH_AccountType: data.verifyAccountNumber,
          ACH_AccountNumber: data.accountNumber,
          ACH_Frequency: Number(data.selectedReport),
          ACH_DebitAmount: data.achDebitAmount,
          ACH_ServiceStatus: Number(data.scheduledPaymentStatus),
          ACH_StopDate: moment(achInfo.ACH_StopDate).format("MM/DD/YYYY"),
          ACH_DebitDueDay: Number(data.selectedPaymentDay),
          ACH_NextPaymentDate: moment(data.selectedDate).format("MM/DD/YYYY"),
          ACH_IndividualName: data.bankAccountName,
          // email: achInfo.emailaddress,
          email: userDetails?.email,
          early_payment_type: selectedOption || "RP",
          early_payment_note: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.update(id, {
        render: res?.data?.[0]?.[1]?.status,
        type: "success",
        isLoading: false,
        ...commonToast,
      });
      setLoading(false);
      setDisabled(false);
      navigate("/loan-details-borrower");
    } catch (error) {
      setLoading(false);
      setDisabled(false);
      toast.update(id, {
        render: "Upload Failed",
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    }
  }

  return (
    <div>
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        {/* Breadscrumb Below */}
        <div className="p-3 pb-0  mt-1">
          <CustomBreadCrumbs
            crumbs={[
              { title: "Loan Details", link: "/loan-details-borrower" },
              { title: "Setup Autopay" },
            ]}
          />
        </div>
        {status === loadingTypes.fulfilled ? (
          <div className="p-3 pb-0  mt-1">
            <div>
              {!achInfo ? (
                <h4 className="my-5">
                  Ach Payments
                  <SpinnerBlock />
                </h4>
              ) : (
                <>
                  {/* <PopupWrapper
                  Component={
                    <div>
                      <h2 className="mb-5">
                        What type of payment do you want to make?
                      </h2>
                     
                    </div>
                  }
                  toShow={showPopup}
                  backdrop="static"
                /> */}

                  <div
                    className="p-3 pb-0  mt-1"
                    style={{ textAlign: "start" }}
                  >
                    <h4 className="my-5">Bank Account ACH Payments</h4>
                    <div
                      style={{
                        borderRadius: "8px",
                        padding: "15px",
                        margin: "20px 4px",
                        background: "#fff",
                      }}
                      className="row"
                    >
                      <FormBox
                        options={newFormArr}
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        errors={errors}
                      />
                      <div>
                        {/* <p>
                          Set up or update ACH Information to automatically make
                          your loan payments. Save time. Save money. Avoid late
                          fees. 0%
                        </p> */}
                        {/* <h3 style={{ color: "#CB7F2C" }}>
                          Sample Authorization for Direct Payment via ACH (ACH
                          Debit)
                        </h3>
                        <div>
                          <p className="fs-6 pt-3 fw-bold pt-2 ">
                            CONSUMER AUTHORIZATION FOR DIRECT PAYMENT VIA ACH
                            (ACH DEBITS){" "}
                          </p>
                          <p className="fs-5 pt-2">
                            Direct Payment via ACH is the transfer of funds from
                            a consumer account for the purpose of making a
                            payment.{" "}
                          </p>
                          <p className="fs-5 pt-2">
                            I (we) authorize ________________________
                            (“COMPANY”) to electronically debit my (our) account
                            (and, if necessary, electronically credit my (our)
                            account to correct erroneous debits1) as follows:
                          </p>
                          <p className="fs-5 pt-2">
                            at the depository financial institution named below
                            (“DEPOSITORY”). I (we) agree that ACH transactions I
                            (we) authorize comply with all applicable law.{" "}
                          </p>
                          <p className="fs-5 pt-2">
                            Depository Name ____________________________________{" "}
                          </p>
                          <p className="fs-5 pt-2">
                            Routing Number _____________________________________{" "}
                          </p>
                          <p className="fs-5 pt-2">
                            Account Number ____________________________________{" "}
                          </p>
                          <p className="fs-5 pt-2">
                            Amount of debit(s) or method of determining amount
                            of debit(s) [or specify range of acceptable dollar
                            amounts authorized]:
                            ______________________________________________.{" "}
                          </p>
                          <p className="fs-5 pt-2">
                            Date(s) and/or frequency of debit(s):
                            ______________________________________________.{" "}
                          </p>
                          <p className="fs-5 pt-2">
                            I (we) understand that this authorization will
                            remain in full force and effect until I (we) notify
                            COMPANY [insert manner of revocation, i.e., in
                            writing, by phone, location, address, etc.] that I
                            (we) wish to revoke this authorization. I (we)
                            understand that COMPANY requires at least [X
                            days/weeks] prior notice in order to cancel this
                            authorization
                          </p>
                          <p className="fs-5 pt-2">
                            Name(s)
                            _____________________________________________________________________________
                          </p>
                          <p className="fs-5 pt-2">
                            Date __________ Signature(s)
                            __________________________________________________________{" "}
                          </p>
                        </div>
                        <div
                          className="d-flex p-5"
                          style={{
                            fontSize: "18px",
                            gap: "36px",
                            marginLeft: "6px",
                          }}
                        >
                          {options?.map((option, i) => (
                            <div key={i} className="form-check p-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                value={option.value}
                                checked={selectedOption === option.value}
                                onChange={handleOptionChange}
                                id={option.label}
                              />
                              <label
                                htmlFor={option.label}
                                className="form-check-label"
                              >
                                {option.label}
                              </label>
                            </div>
                          ))}
                        </div> */}
                        {/* {selectedOption && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handlePaymentOptions}
                          >
                            {titleNameConst?.[selectedOption]}
                          </button>
                        )}
                      </div>
                      <div>
                        <FormBox
                          options={[
                            {
                              title: "Choose Frequency",
                              field: "selectedReport",
                              type: "select",
                              options: ACHPaymentTypeOptions,
                              className: "mt-5",
                            },
                          ]}
                          register={register}
                          watch={watch}
                          setValue={setValue}
                          errors={errors}
                        />

                        {selectedReportWatch === "0" && (
                          <span
                            className="p-3 d-block"
                            style={{ backgroundColor: "#d9edf7" }}
                          >
                            * You have selected a One-Time payment, which will
                            be processed on the date you select below. To
                            Schedule Monthly recurring, select from the drop
                            down above.
                          </span>
                        )}
                        {selectedReportWatch === "1" && (
                          <span
                            className="p-3 d-block"
                            style={{ backgroundColor: "#d9edf7" }}
                          >
                            * You have selected automatic recurring monthly ACH
                            Payments. The amount of these transactions will be
                            the amount of that respective month's billing
                            statement. The billed amount each month may vary
                            slightly, as it is calculated on the 1st of each
                            month for the total number of days in the prior
                            month, plus any other activity on the account (such
                            as any additional advances). Please refer to your
                            monthly billing statement, emailed & mailed on the
                            20th of each month for the upcoming month (finalized
                            on the 1st of each month for the prior month). You
                            can also find a copy of your statement under the
                            'Attachments' section on this portal.
                          </span>
                        )}
                      </div>
                      <div>
                        <button
                          type="button"
                          className="mt-5 btn text-white fw-bold btn btn-primary"
                          onClick={toggleBankInfo}
                        >
                          {achInfo?.ACH_IndividualName} - Checking account
                          ending in{" "}
                         
                          {achInfo?.ACH_AccountNumber.slice(0, -4).replace(
                            /./g,
                            "*"
                          ) + achInfo?.ACH_AccountNumber.slice(-4)}
                        </button>
                        {showBankInfo && (
                          <div className="p-5 border border-5">
                            <img
                              width={isLargeDevice ? "650" : "450"}
                              src={check_example}
                              alt="The lower-left  of a bank check, indicating the routing number is typically found on the bottom left and the account number on the bottom center. "
                            />
                            <div style={{ color: "green" }}>
                              {routingDetails.customer_name} -{" "}
                              {routingDetails.city}, {routingDetails.state}{" "}
                              {routingDetails.zip}{" "}
                            </div>
                            <FormBox
                              options={checkingFormArr}
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              errors={errors}
                            />
                            {routingDetails?.message !== "OK" ||
                            routingNumber?.length !== 9 ? (
                              <p style={{ color: "red" }}>
                                Please enter a valid routing number
                              </p>
                            ) : null}
                          </div>
                        )}
                      </div>
                      <div>
                        <Form.Label className="mt-5 fw-bold">
                          ACH Debit Amount*
                        </Form.Label>
                        <div>
                          <div className="input-group d-flex align-items-center justify-content-start">
                            <span
                              className="input-group-addon py-3 px-5 rounded"
                              style={{ backgroundColor: "#999" }}
                            >
                              $
                            </span>
                            <input
                              type="number"
                              className="form-control"
                              style={{ maxWidth: "340px" }}
                              placeholder="Price"
                              {...register("achDebitAmount")}
                            />
                            <button
                              type="button"
                              className="btn ml-3 text-white fw-bold btn btn-primary"
                              onClick={toggleBill}
                            >
                              View Bills
                            </button>
                          </div>
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            {errors?.achDebitAmount?.message}
                          </div>
                          {selectedOption === "RP" ? (
                            <span
                              className="p-3 d-inline-block"
                              style={{ backgroundColor: "#d9edf7" }}
                            >
                              This is a billed loan account and you will be
                              charged the amount due on your billing statement
                              each month.
                            </span>
                          ) : (
                            ""
                          )}
                          {viewBill && (
                            <div
                              className="d-flex mt-3 justify-content-center align-items-center border p-3"
                              style={{ maxWidth: "1000px" }}
                            >
                              <iframe
                                src={`https://servicing.loans/billing-attachments/${accountId}`}
                                height="400"
                                width="618"
                                title="bill"
                              ></iframe>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex flex-column">
                        <button
                          type="button"
                          className="btn mt-5 text-white fw-bold btn btn-primary"
                          style={{
                            width: "fit-content",
                          }}
                          onClick={() => navigate(`/same-day-payment`)}
                        >
                          Make a Same Day Payment
                        </button>
                        {/* <Form.Label className="mt-5 fw-bold">
                        Scheduled Payment Status *
                      </Form.Label>
                      <Select
                        classNamePrefix="select"
                        {...register("scheduledPaymentStatus")}
                        value={
                          scheduledPaymentStatusWatch
                            ? scheduledPaymentStatusWatch.label
                            : null
                        }
                        options={scheduledPaymentStatusOptions}
                        onChange={(e) =>
                          setValue("scheduledPaymentStatus", e.value)
                        }
                      /> */}
                        {/* <FormBox
                          options={[
                            {
                              title: "Scheduled Payment Status *",
                              field: "scheduledPaymentStatus",
                              type: "select",
                              options: scheduledPaymentStatusOptions,
                              className: "mt-5 col-6",
                            },
                            {
                              title: "Scheduled Payment Date",
                              field: "selectedDate",
                              type: "date",
                              minDate: new Date(moment().add(1, "days")),
                              filter: true,
                              className: "mt-5 col-6",
                            },
                          ]}
                          register={register}
                          watch={watch}
                          setValue={setValue}
                          errors={errors}
                        /> */}
                      </div>

                      {/* {selectedOption === "RP" ? (
                        <div>
                          <FormBox
                            options={[
                              {
                                title:
                                  "Select Payment Day of All Future Months Automatic Payments",
                                field: "selectedPaymentDay",
                                type: "select",
                                options: aCHDebitDueDayOptions,
                                className: "mt-5",
                              },
                            ]}
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            errors={errors}
                          />
                          {showAlert && (
                            <div className="alert alert-error p-5" role="alert">
                              <p>
                                Only one ACH payment can be scheduled at a time.
                                You already have a payment scheduled for{" "}
                                <strong>{scheduledDate}</strong>.
                              </p>
                              <p>
                                You will be <strong>CHANGING </strong>this
                                payment rather than creating a new one.
                              </p>
                            </div>
                          )}
                        </div>
                      ) : (
                        ""
                      )} */}
                      <div>
                        {/* <Form.Label className="mt-5 fw-bold">
                          Authorization *
                        </Form.Label>
                        <p>
                          I hereby authorize Superior Loan Servicing to debit my
                          account. If the above noted payment dates fall on a
                          weekend or holiday, I understand that the payments may
                          be executed on the next business day. I understand
                          that recurring monthly payments will be debited for
                          the amount billed each month or the payment due each
                          month including any unpaid charges and/or late
                          charges. For ACH debits from my checking/savings
                          account, I understand that because these are
                          electronic transactions, these funds may be withdrawn
                          from my account as soon as the date entered above. In
                          the case of an ACH Transaction being rejected for
                          Non-Sufficient Funds (NSF) I understand that Superior
                          Loan Servicing may at its discretion attempt to
                          process the charge again within 30 days, and agree to
                          an additional $45 charge for each attempt returned NSF
                          which will be initiated as a separate transaction from
                          the authorized recurring payment. I acknowledge that
                          the origination of ACH transactions from my account
                          must comply with the provisions of U.S. law. I certify
                          that I am an authorized user of this bank account and
                          will not dispute these scheduled transactions with my
                          bank; so long as the transactions correspond to the
                          terms indicated in this authorization. All ACH
                          payments post on the next business day following the
                          date they are scheduled. All payments are considered
                          received on the date of posting and not the date they
                          are scheduled. Payments that are scheduled on the last
                          day of a grace period will not post until the
                          following business day and the account may be subject
                          to a late charge.
                        </p>
                        <Form.Label className="d-flex align-items-center">
                          <input
                            type="checkbox"
                            className="m-3"
                            {...register("authorization")}
                          />
                          Yes
                        </Form.Label> */}
                        {/* <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {errors?.authorization?.message}
                        </div> */}
                      </div>
                      <div>
                        {/* <LoadingButton
                          loading={loading}
                          disabled={disabled}
                          type="submit"
                          className="btn btn-primary text-white"
                          title={"Submit"}
                          onClick={handleSubmit(handleAuthentication)}
                        /> */}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        ) : status === loadingTypes.loading ? (
          <div style={{ paddingTop: "8rem" }}>
            <SpinnerBlock height="50vh" />
          </div>
        ) : status === loadingTypes.error ? (
          <div>Some error occured</div>
        ) : null}{" "}
      </section>
      <AuthenticationPopup
        otpPopup={otpPopup}
        setOtpPopup={setOtpPopup}
        setIsAuthenticated={setIsAuthenticated}
      />
    </div>
  );
};

export default NewBankAccountACHPayments;

const newFormArr = [
  {
    type: "content",
    content: (
      <div>
        <div>
          <h3 style={{ color: "#CB7F2C" }} className="pb-4">
            Sample Authorization for Direct Payment via ACH (ACH Debit)
          </h3>
        </div>
        {/* <p className="fs-6 ">
          CONSUMER AUTHORIZATION FOR DIRECT PAYMENT VIA ACH (ACH DEBITS){" "}
        </p> */}
        <p className="fs-5 pt-2">
          CONSUMER AUTHORIZATION FOR DIRECT PAYMENT VIA ACH (ACH DEBITS)
        </p>
        <p className="fs-5 pt-2">
          Direct Payment via ACH is the transfer of funds from a consumer
          account for the purpose of making a payment.{" "}
        </p>
      </div>
    ),
    className: "col-12",
  },
  {
    type: "content",
    content: <p className="fs-5 pt-2">I (we) authorize</p>,
    className: "col-2",
  },
  {
    title: "company",
    field: "company",
    className: "col-2",
    type: "text",
  },
  {
    type: "content",
    content: (
      <p className="fs-5 pt-2">
        (“COMPANY”) to electronically debit my (our) account (and, if necessary,
        electronically credit my (our) account to correct erroneous debits1) as
        follows:
      </p>
    ),
    className: "col-8",
  },
  {
    title: "Select One",
    field: "accountType",
    type: "radio",
    options: [
      {
        title: "Checking Account",
        value: "CheckingAccount",
      },
      {
        title: "Savings Account",
        value: "SavingsAccount",
      },
    ],
    className: "col-12",
  },
  {
    type: "content",
    content: (
      <p className="fs-5 pt-2">
        at the depository financial institution named below (“DEPOSITORY”). I
        (we) agree that ACH transactions I (we) authorize comply with all
        applicable law.{" "}
      </p>
    ),
    className: "col-12",
  },
  {
    title: "Depository Name",
    field: "DepositoryName",
    className: "col-12",
    type: "text",
  },
  {
    title: "Routing Number",
    field: "RoutingNumber",
    className: "col-12",
    type: "text",
  },
  {
    title: "Account Number",
    field: "AccountNumber",
    className: "col-12",
    type: "text",
  },
  // {
  //   type: "content",
  //   content: <p className="fs-5 pt-2">
  //   Amount of debit(s) or method of determining amount
  //   of debit(s) [or specify range of acceptable dollar
  //   amounts authorized]:

  // </p>,
  //   className: "col-12"
  // },
  {
    title:
      "Amount of debit(s) or method of determining amount of debit(s) [or specify range of acceptable dollar amounts authorized]:",
    field: "DebitAmount",
    className: "col-12",
    type: "text",
  },
  {
    title: "Date(s) and/or frequency of debit(s):",
    field: "debitFrequency",
    className: "col-12",
    type: "date",
  },
  {
    type: "content",
    content: (
      <p className="fs-5 pt-2">
        I (we) understand that this authorization will remain in full force and
        effect until I (we) notify COMPANY [insert manner of revocation, i.e.,
        in writing, by phone, location, address, etc.] that I (we) wish to
        revoke this authorization. I (we) understand that COMPANY requires at
        least [X days/weeks] prior notice in order to cancel this authorization
      </p>
    ),
    className: "col-12",
  },
  {
    title: "Names(s)",
    field: "Names",
    className: "col-12",
    type: "text",
  },
  {
    title: "Date",
    field: "Dates",
    className: "col-6",
    type: "date",
  },
  {
    title: "Signature",
    field: "signature",
    className: "col-6",
    type: "sign",
  },
];

const options = [
  { label: "Regular Payment", value: "RP" },
  { label: "Principal Pay Down", value: "PP" },
  { label: "Other Fees and Charges", value: "OF" },
];

const ACHPaymentTypeOptions = [
  { label: "Only Once", value: "0" },
  { label: "Monthly", value: "1" },
];

const scheduledPaymentStatusOptions = [
  { label: "Active", value: "1" },
  { label: "Inactive", value: "2" },
];
const aCHDebitDueDayOptions = Array.from({ length: 28 }, (_, i) => ({
  label: `${i + 1}`,
  value: `${i + 1}`,
}));

const AccountTypeOptions = [
  { label: "Checking", value: "0" },
  { label: "Savings", value: "1" },
];
const checkingFormArr = [
  {
    title: "Name on Bank Account *",
    field: "bankAccountName",
    type: "text",
  },
  {
    title: "Routing Number *",
    field: "routingNumber",
    type: "text",
  },
  {
    title: "Account Number *",
    field: "accountNumber",
    type: "text",
  },
  {
    title: "Account Type",
    field: "verifyAccountNumber",
    type: "select",
    options: AccountTypeOptions,
  },
];
const titleNameConst = {
  RP: "Regular Payment",
  PP: "Principal Pay Down",
  OF: "Other Fees and Charges",
};
